import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { WalletModelShort } from '@root/entities/wallet/ui'
import { WalletAddressTruncated } from '@root/entities/wallet/ui/common/wallet-address-truncated'
import { AmountFormatted } from '@root/shared/core/format'

import type { CurrencyModel } from '@root/entities/currency'
import type { WalletModel } from '@root/entities/wallet/atoms'
import type BigNumber from 'bignumber.js'

type TransferCardProps = {
  balance: BigNumber
  wallet: WalletModel
  currency: CurrencyModel
}

export const TransferWalletInfo: React.FC<TransferCardProps> = ({
  wallet,
  balance,
  currency,
}) => {
  return (
    <Root>
      <WalletModelShort wallet={wallet} />
      <Line>
        <Address walletAddress={wallet.address} />
        <Balance>
          <AmountFormatted
            amount={balance}
            currency={currency.ticker}
            roundingMode="trunc"
          />
        </Balance>
      </Line>
    </Root>
  )
}

const Balance = styled(Typography).attrs({
  variant: 'body4-bold',
  component: 'div',
})`
  color: var(--text-9);
`

const Address = styled(WalletAddressTruncated)`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const Line = styled.div`
  padding-left: 14px;

  display: grid;
  justify-content: start;
  align-content: start;
  grid-template-columns: auto auto;
  gap: 10px;
`

const Root = styled.div`
  display: grid;
  gap: 4px;
`
